function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero",
  stroke: "#000",
  strokeWidth: .2
}, React.createElement("path", {
  d: "M13.599 8.64L9.806 6.226a.346.346 0 0 0-.53.291v4.828a.345.345 0 0 0 .53.29l3.793-2.413a.346.346 0 0 0 0-.582zm-3.633 2.077V7.145l2.805 1.786-2.805 1.786z"
}), React.createElement("path", {
  d: "M20.655 1H1.345A.345.345 0 0 0 1 1.345v15.172c0 .19.154.345.345.345h19.31c.19 0 .345-.154.345-.345V1.345A.345.345 0 0 0 20.655 1zM4.448 8.586H1.69V5.483h2.758v3.103zm-2.758.69h2.758v3.103H1.69V9.276zm3.448 3.448V1.69h11.724v14.482H5.138v-3.448zM20.31 8.586h-2.758V5.483h2.758v3.103zm-2.758.69h2.758v3.103h-2.758V9.276zM20.31 1.69v3.103h-2.758V1.69h2.758zm-18.62 0h2.758v3.103H1.69V1.69zm0 14.482V13.07h2.758v3.103H1.69zm18.62 0h-2.758V13.07h2.758v3.103z"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 22,
  height: 17,
  viewBox: "0 0 22 17"
}, props), _ref);

export default __webpack_public_path__ + "static/media/video-post.f9483f00.svg";
export { SvgComponent as ReactComponent };